import API from "../../services/API";
import axios from "axios";

const api = () => axios.create({
    headers: {
        common: {
            'Authorization': Intellibrand.token(),
        },
    },
});

const Intellibrand = {

    fetchOffer(ean) {
        return api()
            .get(
                this.url() + '/product/' + ean,
            )
            .then((res) => {
                return res.data.data;
            })
    },

    fetchOffers(eans) {

        return api()
            .get(
                this.url() + '/products',
                {
                    headers: {
                        'products': eans.join(',')
                    }
                }
            )
            .then((res) => {
                return res.data.data;
            })

    },

    token() {

        if (window.INTELLIBRAND_TOKEN) {
            return window.INTELLIBRAND_TOKEN;
        }

        let element = document.head.querySelector('meta[name="intellibrand-token"]');

        if (!element) {
            console.error("Could not find Intellibrand Token element in page!");
            return '';
        }

        return window.INTELLIBRAND_TOKEN = element.content;

    },

    url() {

        if (window.INTELLIBRAND_URL) {
            return window.INTELLIBRAND_URL;
        }

        let element = document.head.querySelector('meta[name="intellibrand-url"]');

        if (!element) {
            console.error("Could not find Intellibrand Token element in page!");
            return '';
        }

        return window.INTELLIBRAND_URL = element.content;

    },

    currency() {

        if (window.INTELLIBRAND_CURRENCY) {
            return window.INTELLIBRAND_CURRENCY;
        }

        let element = document.head.querySelector('meta[name="intellibrand-currency"]');

        if (!element) {
            console.error("Could not find Intellibrand Currency element in page!");
            return 'R$';
        }

        console.log("Intellibrand currency: ", element.content);

        return window.INTELLIBRAND_CURRENCY = element.content;

    },

    hasDecimals() {

        if (window.INTELLIBRAND_DECIMALS) {
            return window.INTELLIBRAND_DECIMALS;
        }

        let element = document.head.querySelector('meta[name="intellibrand-decimals"]');

        if (!element) {
            console.error("Could not find Intellibrand Decimals element in page!");
            return true;
        }

        console.log("Intellibrand decimals: ", element.content);

        return window.INTELLIBRAND_DECIMALS = (element.content === 'true');

    }


}

export default Intellibrand;
